import $ from 'jquery'

let el = null

const sdown = window.matchMedia('(min-width: 1024px)')

const eventFooterHeight = sdown.matches ? 88 : 16

export function initialise() {
  $(document).on('click', '[data-toggle*="session-select"]', event => {
    // save the current element so we can "click" it programmatically
    el = event.currentTarget
    const isOpen = event.currentTarget.classList.contains('open')
    if (isOpen) {
      setSessionSelectMaxHeight()
      $(document).on('keydown', detectEscapeKey)
      $(document).on('mousedown', detectClickOutside)
      $(document).on('touchstart', detectClickOutside)
    } else {
      $(document).off('keydown', detectEscapeKey)
      $(document).off('mousedown', detectClickOutside)
      $(document).off('touchstart', detectClickOutside)
    }
  })
}

function setSessionSelectMaxHeight() {
  const innerEl = document.querySelector('[data-session-select-inner]')
  if (!innerEl) {
    console.error('data-session-select-inner element not found')
    return
  }
  const rect = innerEl.getBoundingClientRect()
  const maxHeight = window.innerHeight - rect.y - eventFooterHeight
  innerEl.style.maxHeight = `${maxHeight}px`
}

function detectEscapeKey(event) {
  if (event.key === 'Escape') {
    $(el).trigger('click')
  }
}

function detectClickOutside(event) {
  if (!$(event.target).parents('[data-toggle-target="session-select"]').length) {
    $(el).trigger('click')
  }
}
